<script lang="ts">
    import gsap from "gsap";
    import { onMount } from "svelte";

    let container: HTMLElement;

    onMount(() => {
        const childSelector = ":scope > *";
        const counters = [...container.querySelectorAll(childSelector)];
        gsap.set(counters, {
            yPercent: 100,
            opacity: 0,
        });
        gsap.to(container.querySelectorAll(childSelector), {
            stagger: 0.5,
            duration: 1,
            yPercent: 0,
            opacity: 1,
            scrollTrigger: container,
        });
    });
</script>

<div class="number-circle-container" bind:this={container}>
    <!-- <div class="inner"> -->
    <slot />
    <!-- </div> -->
</div>

<style lang="scss">
    @import "./src/vars";

    .number-circle-container {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        font-size: 1.1rem;
        margin: auto;
        max-width: 1600px;
        @media (max-width: 1500px) {
            font-size: 0.9rem;
        }
        @media (max-width: 1000px) {
            font-size: 0.8rem;
        }
        @media (max-width: 800px) {
            font-size: 0.7rem;
        }
        .inner {
            width: auto;
            position: relative;
        }
    }
</style>
